// extracted by mini-css-extract-plugin
export var option = "_49-0";
export var optionCard = "_49-f";
export var optionContent = "_49-g";
export var optionIcon = "_49-i";
export var optionIconBox = "_49-h";
export var optionLabel = "_49-j";
export var optionPill = "_49-m";
export var optionPillBadge = "_49-p";
export var optionPillIcon = "_49-n";
export var optionPillLabel = "_49-o";
export var optionRadio = "_49-k";
export var optionRadioInner = "_49-l";
export var optionReveal = "_49-2";
export var optionRevealDelay0 = "_49-3";
export var optionRevealDelay1 = "_49-4";
export var optionRevealDelay10 = "_49-d";
export var optionRevealDelay11 = "_49-e";
export var optionRevealDelay2 = "_49-5";
export var optionRevealDelay3 = "_49-6";
export var optionRevealDelay4 = "_49-7";
export var optionRevealDelay5 = "_49-8";
export var optionRevealDelay6 = "_49-9";
export var optionRevealDelay7 = "_49-a";
export var optionRevealDelay8 = "_49-b";
export var optionRevealDelay9 = "_49-c";
export var optionSelected = "_49-1";